// client/src/components/common/Footer.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { isAndroid } from 'react-device-detect';

import './Footer.css';

function Footer() {
    const { t, i18n } = useTranslation();

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    const isRTL = i18n.language === 'ar';

    return (
        <footer className={`footer ${isRTL ? 'rtl' : ''}`}>
            {/* Agreement Links - Full Width */}
            {!isAndroid ? (
                <>
            <div className="footer-agreements-wrapper">
                <div className="container"> {/* Use the standard container here */}
                    <div className="footer-agreements">
                        <Link to="/privacy-policy">{t('Register.privacyPolicy')}</Link>
                        <span> | </span>
                        <Link to="/cookies-policy">{t('Register.cookiesPolicy')}</Link>
                        <span> | </span>
                        <Link to="/user-agreement">{t('Register.userAgreement')}</Link>
                    </div>
                </div>
            </div>
            </>
            ) : null}
            {/* Copyright and Language Switcher -  Standard container */}
            <div className="footer-bottom-wrapper">
                <div className="container">  {/*Use the standard container here */}
                    <div className={`copyright ${isRTL ? 'rtl' : ''}`}>
                        &copy; {new Date().getFullYear()} beinSmart.cloud. {t('footer.allRightsReserved')}
                    </div>
                    <div className="language-switcher">
                        <span onClick={() => changeLanguage('en')} className="language-link">{t('footer.english')}</span>
                        <span> - </span>
                        <span onClick={() => changeLanguage('fr')} className="language-link">{t('footer.french')}</span>
                        <span> - </span>
                        <span onClick={() => changeLanguage('ar')} className="language-link">{t('footer.arabic')}</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;